import styled from "styled-components";
import { 
    businessTypePrimaryColor 
} from '../../../themes';

export const TypeColorIndicator = styled.div`
    flex-basis: 100%;
    height: 5px;
    background-color: ${businessTypePrimaryColor()};
`;